package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

/**
 * OIDC Login Response
 * Contains the authorization URL and state parameter for the OAuth flow
 */
@Serializable
data class OidcLoginResponseDto(
    val authorization_url: String,
    val state: String,
)

/**
 * OIDC Callback Response
 * Response after successful OIDC authentication
 */
@Serializable
data class OidcCallbackResponseDto(
    val success: Boolean,
    val data: OidcUserDataDto?,
)

/**
 * OIDC User Data
 * User information returned from OIDC callback
 */
@Serializable
data class OidcUserDataDto(
    val platform_user_id: String,
    val email: String?,
    val name: String?,
    val active_tenant_id: String?,
    val tenant_role: String?,
)

/**
 * OIDC Config Response
 * OpenID Connect configuration metadata
 */
@Serializable
data class OidcConfigResponseDto(
    val issuer: String,
    val authorization_endpoint: String,
    val scopes_supported: List<String> = emptyList(),
    val response_types_supported: List<String>? = null,
)

/**
 * OIDC Token Refresh Response
 */
@Serializable
data class OidcRefreshResponseDto(
    val success: Boolean,
    val data: OidcUserDataDto?,
)

/**
 * OIDC Logout Response
 */
@Serializable
data class OidcLogoutResponseDto(
    val success: Boolean,
    val message: String,
)
